import React, { useState, useEffect } from 'react';
import MUIDataTable from "mui-datatables";
import axios from "axios";
import { Button, Box } from "@material-ui/core";
import moment from "moment";
import { createTheme, ThemeProvider } from '@material-ui/core/styles'


const UsersTable = () => {
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const GetData = async () => {
      try {
        const result = await axios.get("/api/eventos");
        setData(result.data);
        console.log(result.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    GetData();
  }, []);

  const onEdit = eventId => {
    window.location.href +=  `/admin/${eventId}`;
  };

  const onRegisterInQRExpositores = expositorId => {
    window.location.href += `/qr/${expositorId}`;
  };

  const onAttendance = eventId => {
    window.location.href += `/attendance/${eventId}`;
  };

  const onRegisterInConferencias = expositorId => {
    window.location.href += `/registroconferenciaqr/${expositorId}`;
  };

  const onAccesoInConferencias = expositorId => {
    window.location.href += `/accesoconferenciaqr/${expositorId}`;
  };  


const columns = [
  { 
    name: "name",  
    label: "Evento", 
    options: { 
      filter: true, 
      sort: true,
    } 
  },
  { 
    name: "eventDate", 
    label: "Fecha", 
    options: { 
      filter: true, 
      sort: true, 
      customBodyRender: (value) => moment(value).format("DD/MM/YYYY"),
    } 
  },
  { 
    name: "preinvitadosCount", 
    label: "Invitados Registrados", 
    options: { 
      filter: true, 
      sort: true,
    } 
  },
  { 
    name: "occupancy", 
    label: "Capacidad", 
    options: { 
      filter: true, 
      sort: true,
    } 
  },
  {
    name: "Acciones",
    options: {
      filter: false,
      sort: false,
      customBodyRenderLite: dataIndex => {
        const event = data[dataIndex];
        return (
          <Box display="flex" gap={1}>
            <Button color="primary" variant="contained" onClick={() => onEdit(event._id)} style={{ marginRight: 4 }}>
              Editar
            </Button>
            <Button color="primary" variant="outlined" onClick={() => onRegisterInConferencias(event._id)} style={{ marginRight: 4 }}>
              Registro conferencia
            </Button>
            <Button color="primary" variant="outlined" onClick={() => onAccesoInConferencias(event._id)} style={{ marginRight: 4 }}>
              Acceso conferencia
            </Button>                      
            <Button color="primary" variant="contained" onClick={() => onAttendance(event._id)}>
              Asistencia
            </Button>
          </Box>
        );
      }
    }
  }
];

  const options = {
    filterType: "dropdown",
    selectableRows: "none",
    rowsPerPage,
    page,
    onChangePage: newPage => setPage(newPage),
    onChangeRowsPerPage: newRows => setRowsPerPage(newRows)
  };

  
const theme = createTheme({
  components: {
    MUIDataTableHeadCell: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center"
        },
      }
  }
}
});


  return (
    <ThemeProvider theme={theme}>
      <MUIDataTable
      title="Eventos"
      data={data}
      columns={columns}
      options={options}
    />
</ThemeProvider>
  );
};

export default UsersTable;